import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '@/store'
import {getToken, getUserId, getType} from '@/utils/auth'

// axios.defaults.withCredentials = true

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,  // api 的 base_url
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {

    if ((localStorage.getItem('token')) && (config.url != 'http://1.116.243.74:18002/api/v1/devices/channelstream') && (config.url != 'http://1.116.243.74:18002/api/v1/ptzcontrol') && (config.url != 'http://1.116.243.74:18002/api/v1/devices/channelsnap') && (config.url != 'http://1.116.243.74:18002/api/v1/record/querydaily') && (config.url != 'http://1.116.243.74:18002/api/v1/devices/record/playback')) {
      config.headers.Authorization = getUserId() + ',' + localStorage.getItem('token') + "," + 'system' + "," + getType()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res.code)
    if (res.code === 0 || res.code === 200 || res.status === "success") {
      return response
    } else {
      if(res.msg && res.msg !== '无设备信息' && res.msg !== '设备已被绑定，不能重复绑定') {
        Message.error(res.msg)
      }
      return Promise.reject(response)
    }
  }, error => {
    console.log('err' + error)// for debug
    // Message({
    //   message: '登录连接超时（后台不能连接，请联系系统管理员）',
    //   type: 'error',
    //   duration: 10 * 1000
    // })
    Message.error(error)
    return Promise.reject(error)
  })

export default service
